import React, { FC } from 'react';
import { getUserLang } from '@mb/lib';
import type { Event } from '@mb/types';
import { getDateFormatted } from '../../helpers/getDateFormatted';

interface EventItemProps {
  event: Event | null;
  index: number;
  isFeatured?: boolean;
  inView?: boolean;
}

export const EventItem: FC<EventItemProps> = (props) => {
  const { event, index, isFeatured, inView = false } = props;

  const userLang = getUserLang();
  const link =
    ENVIRONMENT_REGION === 'EU'
      ? `/${userLang}/${event?.internal_url}`
      : `/${event?.internal_url}` || '#';

  if (!event) {
    return null;
  }

  if (isFeatured) {
    return (
      <li
        className="w-full pr-4 m-0 flex-none aspect-square sm:p-0 sm:m-0 sm:w-1/2 md:aspect-video"
        key={index}
      >
        <a href={link} className="block relative w-full h-full">
          {event?.thumb_image && (
            <img
              className="w-full h-full object-cover overflow-hidden rounded-[20px]"
              src={event?.thumb_image}
              srcSet={event?.thumb_image}
              alt={event?.title}
            />
          )}
          {event?.header_logo && (
            <div className="absolute top-4 left-4 z-[5]">
              <img
                src={event?.header_logo}
                srcSet={event?.header_logo}
                alt={event?.title}
                className="w-3/4 sm:w-auto max-w-[100px]"
              />
            </div>
          )}
          <div className="w-full h-full absolute left-0 top-0 text-white p-5 flex flex-col items-start justify-end">
            <p className="text-xs m-0 sm:text-base">
              {getDateFormatted(event, userLang)}
            </p>
            <h3 className="font-bold text-lg">{event.title}</h3>
          </div>
        </a>
      </li>
    );
  }
  return (
    <li className="p-0 m-0 flex-none">
      <a href={link} className="block relative">
        {event?.thumb_image && (
          <img
            className="object-cover overflow-hidden rounded-[20px] aspect-square md:aspect-video mb-2"
            src={event?.thumb_image}
            srcSet={event?.thumb_image}
            alt={event?.title}
          />
        )}
        {event?.header_logo && (
          <div className="absolute top-4 left-4 z-[5]">
            <img
              src={event?.header_logo}
              srcSet={event?.header_logo}
              alt={event?.title}
              className="w-3/4 sm:w-auto max-w-[60px]"
            />
          </div>
        )}
        <div className="w-full h-full flex flex-col">
          <p className="font-bold text-2xs m-0 sm:text-xs truncate text-mbgray-200">
            {getDateFormatted(event, userLang)}
          </p>
          <h3 className="font-bold text-smr truncate sm:text-base">
            {event.title}
          </h3>
          <div className="text-mbgray-200 text-xs m-0 truncate sm:text-smr">
            {event.subtitle}
          </div>
        </div>
      </a>
    </li>
  );
};
